module.exports = __webpack_public_path__ + "static/media/volleyball.ff8fa736.jpeg";